import { Queue } from "websocket-ts";
import { StateEnum } from "@/api/stores/use-api-store";

export interface PubMsgQueueItem {
    fc: (state) => void;
    stateName?: StateEnum;
    messageId?: string;
}

/**
 * A pub msg queue is a queue that has unlimited capacity. Reading from a ring queue will return the oldest
 * element and effectively remove it from the queue.
 *
 * Similar to websocket-ts RingQueue but with added support for sorting by messageId (and unfortunately less performant).
 */
export class PubMsgQueue implements Queue<PubMsgQueueItem> {
    private elements: PubMsgQueueItem[];

    constructor() {
        this.elements = new Array<PubMsgQueueItem>(0);
    }

    add(element: PubMsgQueueItem): void {
        this.elements.unshift(element);
    }

    clear() {
        this.elements = [];
    }

    forEach(fn: (element: PubMsgQueueItem) => unknown) {
        for (let i = 0; i < this.elements.length; i++) {
            fn(this.elements[i]);
        }
    }

    length(): number {
        return this.elements.length;
    }

    isEmpty(): boolean {
        return !this.elements.length;
    }

    peek(): PubMsgQueueItem | undefined {
        return this.isEmpty() ? undefined : this.elements.at(-1);
    }

    read(): PubMsgQueueItem | undefined {
        return this.elements.pop();
    }

    sort() {
        this.elements.sort((a: PubMsgQueueItem, b: PubMsgQueueItem) => (a?.messageId > b?.messageId ? -1 : 1));
    }
}
